import { Component, HostBinding, Inject, Input, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { CmsService } from '@spartacus/core';
import { PageSlotModule } from '@spartacus/storefront';
import { RecipeSearchComponent } from '@seb/web-common/core/components/recipe/recipe-search/recipe-search.component';
import { AbstractRecipeCategoryPageComponent } from '../abstract-recipe-category-page/abstract-recipe-category-page.component';
import { LazyLoadingService, LocationService } from '@seb/web-common/core/services';

@Component({
  selector: 'wc-recipe-category-page',
  templateUrl: './recipe-category-page.component.html',
  styleUrls: ['./recipe-category-page.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [PageSlotModule, RecipeSearchComponent]
})
export class RecipeCategoryPageComponent extends AbstractRecipeCategoryPageComponent {
  protected readonly destroy$: Subject<void> = new Subject();

  @Input() class = '';
  @HostBinding('class')
  get hostClasses(): string {
    return [this.class, 'wc-template'].filter(Boolean).join(' ');
  }

  constructor(
    protected cmsService: CmsService,
    protected lazyLoadingService: LazyLoadingService,
    protected locationService: LocationService,
    @Inject(PLATFORM_ID) protected platformId: any
  ) {
    super(cmsService, lazyLoadingService, locationService);
  }
}
